var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8728 19L13.5819 13M19.8728 19V14.2M19.8728 19H14.8401M1 14.2V19M1 19H6.03275M1 19L7.29094 13M19.8728 5.8V1M19.8728 1H14.8401M19.8728 1L13.5819 7M1 5.8V1M1 1H6.03275M1 1L7.29094 7",
    stroke: "#3C2464",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandNavigation);
export default __webpack_public_path__ + "static/media/expand_navigation.c63f544a1841ac6107e2d0ee7ce3f07b.svg";
export { ForwardRef as ReactComponent };